<section class="mt-26 ml-28 mr-8 flex flex-col gap-4">
  <app-vehicle-search-bar
    [viewMode]="viewMode()"
    [groupBy]="groupBy()"
    [zoom]="zoom()"
    [visibleHours]="visibleHours()"
    [visibleDays]="visibleDays()"
    [filters]="filters()"
    [viewOptions]="viewOptions()"
    (searchEventEmitter)="searchValue.set($event)"
    (filterEventEmitter)="onFilter($event)"
    (changeViewMode)="onChangeViewMode($event)"
    (changeGroupBy)="onChangeGroupBy($event)"
    (changeZoom)="zoom.set($event)"
    (changeViewOptions)="onChangeViewOptions($event)"
    (goToNowEventEmitter)="goToNow()"
    (newVehicleEventEmitter)="onNewVehicle()"
  ></app-vehicle-search-bar>
  <app-vehicle-schedule
    [viewMode]="viewMode()"
    [groupBy]="groupBy()"
    [zoom]="zoom()"
    [searchValue]="searchValue()"
    [filters]="filters()"
    [visibleHours]="visibleHours()"
    [visibleDays]="visibleDays()"
    [viewOptions]="viewOptions()"
    [selectedRowId]="selectedVehicle()?.id ?? selectedDriver()?.id"
    [collapsedRows]="collapsedRows()"
    (collapsedRowsChange)="onChangeCollapsedRows($event)"
    (selectRowEventEmitter)="onSelectRow($event)"
    (changeTimelineVisibility)="onChangeTimelineVisibility($event)"
  ></app-vehicle-schedule>
  @if (newVehicle() || selectedVehicle()) {
    <app-vehicle-details
      class="z-30"
      [vehicle]="selectedVehicle()"
      [newVehicle]="newVehicle()"
      (closeDetails)="closeDetails()"
      (saveVehicle)="onSaveVehicle($event)"
      (changeStatusEventEmitter)="onChangeStatus($event)"
    ></app-vehicle-details>
  }
  @if (selectedDriver()) {
    <app-user-details [user]="selectedDriver()" [newUser]="false" (userEdited)="onDriverEdited($event)" (closeDetails)="closeDetails()"></app-user-details>
  }
</section>
<app-modal-confirmation
  [id]="'deactivateVehicle'"
  [modal]="deactivateVehicleModal"
  [hidden]="!deactivateVehicleShowed"
  [shown]="deactivateVehicleShowed"
  [title]="'vehicles.actions.deactivate.title'"
  [text]="'vehicles.actions.deactivate.description'"
  [icon]="images.booking.warning"
  [centerText]="true"
  [sameLineButtons]="true"
  (action)="deactivateVehicleAction()"
/>
